import React from 'react';
import { cn } from '@/utils/cn';
import type { ToastItem } from '@/Context/ToastContext';
import { templateData } from '@/data/content';
import Button from '@/components/ui/Button';
import { CloseIcon } from '@/components/ui/Icons';

interface ToastContainerProps {
    toast: ToastItem | null;
    onClose: () => void;
}

const typeClasses: Record<string, string> = {
    success: 'bg-[#0f8a65]',
    warning: 'bg-amber-600',
    error: 'bg-[#b42318]',
    info: 'bg-blue-600',
};

const ToastContainer: React.FC<ToastContainerProps> = ({ toast, onClose }) => {
    if (!toast) {
        return null;
    }

    return (
        <div className="fixed top-[84px] left-3 right-3 z-[999999] pointer-events-none lg:top-[110px] lg:left-auto lg:right-4">
            <div
                className={cn(`global-toast-${toast.type}`, 'flex items-center justify-between gap-3 px-3 py-2.5 rounded-[10px] text-white shadow-[0_10px_20px_rgba(16,24,40,0.25)] pointer-events-auto w-full lg:min-w-[280px] lg:max-w-[360px]', typeClasses[toast.type] ?? 'bg-gray-700')}
            >
                <span>{toast.message}</span>
                <Button
                    variant="ghost"
                    type="button"
                    onClick={onClose}
                    aria-label={templateData.close_label}
                    className="!p-0 text-inherit hover:text-white leading-none flex-shrink-0 border-0"
                >
                    <CloseIcon className="w-4 h-4" />
                </Button>
            </div>
        </div>
    );
};

export default ToastContainer;
